import React from "react";

const ExamInfo = ({ data }) => {
  const { exam } = data;

  if (!exam) {
    return null;
  }

  const isCurrentExam =
    exam.exam_year >= exam.current_year &&
    exam.weeks_before_exam <= 53 &&
    exam.weeks_before_exam >= 0;

  if (!isCurrentExam) {
    return null;
  }

  const isLastWeek =
    exam.days_before_exam >= 0 &&
    exam.days_before_exam <= 7;

  const title = isLastWeek
    ? `Egzamin ${data.qualification_symbol} ` +
      `[${exam.exam_day} ${exam.exam_month} ${exam.exam_year}] ` +
      `Dni do egzaminu: ${exam.days_before_exam}`
    : `Egzamin ${data.qualification_symbol} ` +
      `[${exam.exam_month} ${exam.exam_year}] ` +
      `Tygodni do egzaminu: ${exam.weeks_before_exam}`;

  return (
    <p
      style={{
        fontSize: "x-small",
        textAlign: "center",
        marginTop: "5px"
      }}
    >
      <span title={title}>
        {isLastWeek
          ? `${exam.exam_month} ${exam.exam_year} [${exam.days_before_exam} dni]`
          : `${exam.exam_month} ${exam.exam_year} [${exam.weeks_before_exam}]`
        }
      </span>
    </p>
  );
};

export default ExamInfo;